export const EVENTS_BG_PALLETE = {
    TANK_LEVEL_READING: '#C6DCF1',
    GAS_SUPPLY: '#A1C6E8',
    PREVENTIVE_MAINTENANCE: '#6FA8DC',
    CONSUMPTION_METER_READING: '#5799D6',
    RECEIPT_DELIVERY: '#3282CD',

    OPERATIONS_START: '#FBDCBC',
    CLIENT_REACTIVATION: '#F9C690',
    CLIENT_DEACTIVATION: '#F6B26B',

    GENERATE_RESIDENTIAL_RECEIPT: '#E9CEDC',
    GENERATE_COMMERCIAL_RECEIPT: '#DAAFC5',
    GENERATE_RESIDENTIAL_INVOICE: '#CC8FAE',
    GENERATE_COMMERCIAL_INVOICE: '#C27BA0',
    GENERATE_GENERAL_PUBLIC_INVOICE: '#AF5081',
    GENERATE_GROUPED_COMMERCIAL_INVOICES: '#8F426A',

    SUPPLY_CUT: '#D2E1E5',
    RECONNECTION: '#B5CED4',
    CORRECTIVE_MAINTENANCE: '#98BBC3',

    RESIDENTIAL_PAYMENT_DEADLINE: '#D5CEE9',
    COMMERCIAL_PAYMENT_DEADLINE: '#B9AFDA'
}

export const EVENTS_FONT_PALLETE = {
    TANK_LEVEL_READING: '#000000',
    GAS_SUPPLY: '#000000',
    PREVENTIVE_MAINTENANCE: '#000000',
    CONSUMPTION_METER_READING: '#000000',
    RECEIPT_DELIVERY: '#FFFFFF',

    OPERATIONS_START: '#000000',
    CLIENT_REACTIVATION: '#000000',
    CLIENT_DEACTIVATION: '#000000',

    GENERATE_RESIDENTIAL_RECEIPT: '#000000',
    GENERATE_COMMERCIAL_RECEIPT: '#000000',
    GENERATE_RESIDENTIAL_INVOICE: '#000000',
    GENERATE_COMMERCIAL_INVOICE: '#000000',
    GENERATE_GENERAL_PUBLIC_INVOICE: '#FFFFFF',
    GENERATE_GROUPED_COMMERCIAL_INVOICES: '#FFFFFF',

    SUPPLY_CUT: '#000000',
    RECONNECTION: '#000000',
    CORRECTIVE_MAINTENANCE: '#000000',

    RESIDENTIAL_PAYMENT_DEADLINE: '#000000',
    COMMERCIAL_PAYMENT_DEADLINE: '#000000'
}